import {Link} from "react-router-dom";
import { useUserContext } from "../contexts/useUserContext.js";

import { FaHome, FaBook } from 'react-icons/fa'
import { HiDocumentReport } from 'react-icons/hi'
import { ImQrcode } from 'react-icons/im'

import { Container, FloatButton } from './styles'
import { RiSideBarFill, RiCloseFill } from 'react-icons/ri'
import { useState } from 'react'

export const Sidebar = () => {
  const { user } = useUserContext();
  const [sidebar, setSidebar] = useState(true);

  const showSidebar = () => {
    setSidebar(!sidebar)
  }

  return (
    <>
    <FloatButton onClick={showSidebar}>
      <RiSideBarFill className='icon'/>
    </FloatButton>
    <Container active={sidebar}>
      <div className='sidebar'>
        <RiCloseFill className='icon close' onClick={showSidebar}/>
        <div className='top-list'>
          <span>Usuário Logado:</span>
          <span>{user.name}</span>
          <Link to='/retailersdashboard' className="text-link">
          <div className='title'>
            <FaHome className='icon'/>
            <span>Página Inicial</span>
          </div>
          </Link>
        </div>
        <div className='midle-list'>
          <ul>
            <Link to='/guia-revendedor' className="text-link">
              <li><FaBook className='icon'/><span>Guia do Revendedor</span></li>
            </Link>
            <Link to='/retailerreports' className="text-link">
              <li><HiDocumentReport className='icon'/><span>Relatório de Revenda</span></li>
            </Link>
            <Link to='/retailernewuser' className="text-link">
              <li><ImQrcode className='icon'/><span>Convidar Usuários</span></li>
            </Link>
          </ul>
        </div>
      </div>
    </Container>
    </>
  )
}

export default Sidebar